<template>
  <div>
    <AuthHeader :title="t('Осталось немного')" class="auth-profile-form__header" />
    <BaseForm
      v-model="formModel"
      :schema="[
        {
          type: FormField.fio,
          name: 'lastName',
          label: t('Фамилия'),
          attrs: { 'placeholder': 'Иванов', 'data-testid': 'auth-last-name-input' },
          required: true,
        },
        {
          type: FormField.fio,
          name: 'firstName',
          label: t('Имя'),
          attrs: { 'placeholder': 'Иван', 'data-testid': 'auth-first-name-input' },
          required: true,
        },
        {
          type: FormField.fio,
          name: 'middleName',
          label: t('Отчество'),
          attrs: {
            'placeholder': 'Иванович',
            'data-testid': 'auth-middle-name-input',
          },
        },
        {
          type: FormField.birthday,
          name: 'birthday',
          label: t('Дата рождения'),
          attrs: { 'data-testid': 'auth-birthday-input' },
          required: true,
        },
        {
          type: requiredContactField ?? AuthMethod.phone,
          name: 'phoneOrEmail',
          label: requiredContactField === AuthMethod.email ? t('Почта') : t('Телефон'),
          attrs: {
            'placeholder': requiredContactField === AuthMethod.email ? 'user@mail.ru' : '+7 (999)-999-99-99',
            'data-testid': 'auth-contact-input',
          },
          required: requiredContactField === AuthMethod.phone,
        },
      ]"
      :when-handle-submit="saveProfile"
    >
      <template #actions="{ nextTabindex }">
        <BaseButton
          with-full
          with-decor
          data-testid="auth-prev-btn"
          @click="emit('back')"
        >
          {{ t('Назад') }}
        </BaseButton>
        <BaseButton
          type="submit"
          variant="primary"
          with-full
          with-decor
          data-testid="auth-next-btn"
          :tabindex="nextTabindex"
        >
          {{ t('Далее') }}
        </BaseButton>
      </template>
    </BaseForm>
    <AuthContactDevelopersBlock class="auth-profile-form__developers" />
  </div>
</template>

<script setup lang="ts">
import type { IProfileForm } from '~/entities/auth'

import { useI18n } from 'vue-i18n'

import { AuthContactDevelopersBlock, AuthHeader, AuthMethod, useAccountStore } from '~/entities/auth'
import { FormField } from '~/shared/const'
import { useNotificationStore } from '~/shared/lib'
import { BaseButton, BaseForm } from '~/shared/ui'
import i18n from '../model/AuthProfileForm.i18n.json'

const emit = defineEmits<{
  (e: 'success'): void
  (e: 'back'): void
}>()

const { t } = useI18n(i18n)
const { notify } = useNotificationStore()
const accountStore = useAccountStore()
const { data, verifiedRegisterCode } = storeToRefs(accountStore)
const { getRequiredContactField } = accountStore

const requiredContactField = computed(getRequiredContactField)

const formModel = ref({
  lastName: data.value.lastName,
  firstName: data.value.firstName,
  middleName: data.value.middleName,
  birthday: data.value.birthday,
  phoneOrEmail: data.value[requiredContactField.value ?? AuthMethod.phone],
})

onMounted(() => {
  if (!verifiedRegisterCode.value) {
    notify({ message: 'Вы не подтвердили код верификации', type: 'error' })
  }
})

async function saveProfile(form: IProfileForm) {
  accountStore.setProfileForm(form)
  emit('success')
}
</script>

<style lang="scss" scoped>
.auth-profile-form__header {
  :deep(.auth-header__title) {
    font-size: rem(30px);
    line-height: rem(33px);
    font-weight: 600;
  }
}

.auth-profile-form__developers {
  margin-top: rem(21px);
}
</style>
